import type { SearchQueryParams } from 'afpnews-api'
import type { Topic, Locale, TopicLocale } from '@/types'
import TopicsConfig from './topics.json'

export function getTopicsForLocale(locale: Locale): Topic[] {
  const topicsLocale = locale as TopicLocale
  return TopicsConfig[topicsLocale] ?? TopicsConfig.en ?? []
}

export function buildTopicColumnParams(
  lang: Locale,
  topicValue: string
): Partial<SearchQueryParams> & { topic: string } {
  return {
    langs: [lang],
    topic: topicValue
  }
}
